import {renderElement} from "./utils/common";
import {ListActions} from "./utils/consts";

export const organizationFill = () => {
  const organizationFillNode = document.querySelector(`.js-fill-organization`);

  const createEvent = (name) => {
    const event = new Event(name, {bubbles: true, cancelable: true});
    return event;
  };

  const getSuggestionItemTemplate = ({
    value,
    data: {
      name: {full_with_opf, short_with_opf},
      address,
      inn,
      okpo,
      kpp,
    },
  }) => `<li class="suggestion__item js-suggestion-item" tabindex="0" ${full_with_opf ? `data-full-name='${full_with_opf}'` : ``} ${
    short_with_opf ? `data-name='${short_with_opf}'` : ``
  }
  ${inn ? `data-inn="${inn}"` : ``} ${okpo ? `data-okpo="${okpo}"` : ``}
  ${kpp ? `data-kpp="${kpp}"` : ``}>
    <span class="suggestion__text suggestion__text--black">${short_with_opf}</span>
    <span class="suggestion__text suggestion__text--sub"><i>ИНН: ${inn} Адрес: ${address.value}</i></span>
  </li>`;

  const fetchSuggestData = async (query) => {
    const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party";
    const token = "877a21dcd1b9e7c03d457821f5d96f8086a7416b";

    const queryObj = {
      query,
      status: ["ACTIVE"],
    };

    const options = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + token,
      },
      body: JSON.stringify(queryObj),
    };

    const result = await fetch(url, options)
      .then((response) => response.json())
      .then((data) => data)
      .catch((error) => console.log("error", error));

    return result;
  };

  if (organizationFillNode) {
    const inputsElements = organizationFillNode.querySelectorAll(`.js-fill-input`);
    const clearInputs = organizationFillNode.querySelector(`.js-fill-org-clear`);

    const nameInput = organizationFillNode.querySelector(`.js-fill-name`);
    const fullNameInput = organizationFillNode.querySelector(`.js-fill-full-name`);
    const innInput = organizationFillNode.querySelector(`.js-fill-inn`);
    const kppInput = organizationFillNode.querySelector(`.js-fill-kpp`);
    const okpoInput = organizationFillNode.querySelector(`.js-fill-okpo`);

    const setOrganization = (element) => {
      nameInput.value = element.dataset.name ? element.dataset.name : ``;
      fullNameInput.value = element.dataset.fullName ? element.dataset.fullName : ``;
      innInput.value = element.dataset.inn ? element.dataset.inn : ``;
      kppInput.value = element.dataset.kpp ? element.dataset.kpp : ``;
      okpoInput.value = element.dataset.okpo ? element.dataset.okpo : ``;
    };

    inputsElements.forEach((input) => {
      const parent = input.parentNode;
      const suggestionListElement = parent.querySelector(`.js-suggestion-list`) || parent.nextElementSibling;

      const setVisibleSugestionList = (list, action) => {
        switch (action) {
          case ListActions.SHOW:
            list.classList.add(`show`);
            document.addEventListener(`click`, withoutListClickHandler);
            break;
          case ListActions.HIDE:
            list.classList.remove(`show`);
            document.removeEventListener(`click`, withoutListClickHandler);
            break;
        }
        list.querySelectorAll(`.js-suggestion-item`).forEach((element) => element.remove());
      };

      const withoutListClickHandler = (evt) => {
        if (evt.target.closest(`.js-suggestion-list`) !== suggestionListElement) {
          suggestionListElement.classList.remove(`show`);
        }
      };

      suggestionListElement.addEventListener(`click`, (evt) => {
        if (evt.target.classList.contains(`js-suggestion-item`) || evt.target.closest(`.js-suggestion-item`)) {
          setOrganization(evt.target.classList.contains(`js-suggestion-item`) || evt.target.closest(`.js-suggestion-item`));
          setVisibleSugestionList(evt.currentTarget, ListActions.HIDE);
          input.dispatchEvent(createEvent(`change`));
        }
      });

      input.addEventListener(`input`, async () => {
        const results = await fetchSuggestData(input.value);

        if (results.suggestions.length) {
          setVisibleSugestionList(suggestionListElement, ListActions.SHOW);
          results.suggestions.forEach((result) => {
            renderElement(suggestionListElement, getSuggestionItemTemplate(result));
          });
        } else {
          setVisibleSugestionList(suggestionListElement, ListActions.HIDE);
        }
      });
    });

    if (clearInputs) {
      clearInputs.addEventListener(`click`, () => {
        inputsElements.forEach((input) => (input.value = ``));
        nameInput.value = ``;
        fullNameInput.value = ``;
        innInput.value = ``;
        kppInput.value = ``;
        okpoInput.value = ``;

        if (organizationFillNode.classList.contains(`order__new-counterparty`)) {
          organizationFillNode.closest(`.order__item`).querySelector(`.js-fill-hint`).style.display = ``;
        }
      });
    }
  }
};
